(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6180],{

/***/ 88579:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/voucher/[purchaseId]",
      function () {
        return __webpack_require__(40272);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94449);
/* harmony import */ var client_contexts_Purchase_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5755);
/* harmony import */ var src_comps_Voucher_mappers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30216);
/* harmony import */ var client_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12654);
/* harmony import */ var src_comps_Page_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(495);
/* harmony import */ var client_types_checkout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43026);
/* harmony import */ var client_pages_Home_Head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77555);
/* harmony import */ var client_components_Header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56411);
/* harmony import */ var client_components_VoucherHeader_MessageHeader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41323);
/* harmony import */ var src_comps_Page__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77288);
/* harmony import */ var src_comps_Voucher_container__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26252);
/* harmony import */ var client_pages_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17954);
/* harmony import */ var client_components_CheckoutContainer_context__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68106);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82066);
/* harmony import */ var src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59806);
/* harmony import */ var src_comps_KindlyChat__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35381);





















var pageId = "voucher";
var VoucherPage = function(param) {
    var config = param.config, translations = param.translations, purchaseId = param.purchaseId, paymentMethods = param.paymentMethods, voucher = param.voucher, property = param.property, ancillariesJSON = param.ancillariesJSON, supportInfoJSON = param.supportInfoJSON;
    var ref;
    var bookingStatuses = voucher === null || voucher === void 0 ? void 0 : (ref = voucher.bookings) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        return item.bookingStatus;
    });
    var isMandatory = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(client_contexts_Purchase_selectors__WEBPACK_IMPORTED_MODULE_3__/* .getIsMandatory */ ._w);
    var purchaseEmail = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(client_contexts_Purchase_selectors__WEBPACK_IMPORTED_MODULE_3__/* .getPurchaseEmail */ .F0);
    var contactEmail = (0,src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_16__/* .useMarket */ .A)().contactEmail;
    var trackingData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, config, (0,src_comps_Voucher_mappers__WEBPACK_IMPORTED_MODULE_4__/* .mapVoucherToTracking */ .ke)(voucher)), {
        isMandatory: isMandatory,
        purchaseEmail: purchaseEmail
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        return new react_query__WEBPACK_IMPORTED_MODULE_15__.QueryClient();
    }), queryClient = ref1[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Page__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        config: config,
        pageId: pageId,
        trackingData: trackingData,
        translations: translations,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(client_pages_styles__WEBPACK_IMPORTED_MODULE_13__/* .Layout */ .A, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_pages_Home_Head__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    language: config.language,
                    market: config.market
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_Header__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    pageId: pageId,
                    contactEmail: contactEmail,
                    hasDirectSales: false,
                    ancillariesJSON: ancillariesJSON
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_VoucherHeader_MessageHeader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    statuses: bookingStatuses,
                    consumer: "voucher"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_CheckoutContainer_context__WEBPACK_IMPORTED_MODULE_14__/* .CheckoutProvider */ .o, {
                    purchaseId: purchaseId,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_query__WEBPACK_IMPORTED_MODULE_15__.QueryClientProvider, {
                        client: queryClient,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Voucher_container__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            pageId: pageId,
                            paymentMethods: paymentMethods,
                            purchaseId: purchaseId,
                            voucher: voucher,
                            property: property,
                            supportInfoJSON: supportInfoJSON
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_KindlyChat__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    purchaseId: purchaseId
                })
            ]
        })
    });
};
VoucherPage.propTypes = {
    config: src_comps_Page_types__WEBPACK_IMPORTED_MODULE_6__/* .typeConfig */ ._,
    paymentMethods: client_types_checkout__WEBPACK_IMPORTED_MODULE_7__/* .typePaymentMethods */ .In,
    purchaseId: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().string),
    translations: client_types__WEBPACK_IMPORTED_MODULE_5__/* .typeAny */ .lP,
    voucher: prop_types__WEBPACK_IMPORTED_MODULE_20___default().instanceOf(Object),
    property: client_types__WEBPACK_IMPORTED_MODULE_5__/* .typeProperty */ ._T,
    ancillariesJSON: client_types__WEBPACK_IMPORTED_MODULE_5__/* .typeAny */ .lP,
    supportInfoJSON: prop_types__WEBPACK_IMPORTED_MODULE_20___default().instanceOf(Object)
};
VoucherPage.pageId = pageId;
VoucherPage.pagePathView = "/booking/voucher/[purchaseId]";
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (VoucherPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2522,3593,876,8080,4890,6146,826,5582,5255,9325,9997,9774,2888,179], function() { return __webpack_exec__(88579); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);